import React from 'react';

const Hint = ({ hint }) => {
    return <h2>Nästa fråga finns {hint}</h2>;
};

export default Hint;